import { userApi } from './user.api';
import type { User } from '../model/types';
import type { SearchParams, Pagination } from '@/shared/lib';

export async function search(
  searchUrl: string,
  searchParams: SearchParams
): Promise<{ data: User[]; metadata: Pagination }> {
  const { search, page, amount, sort, filter, searchField } = searchParams;

  const result = await userApi.search({
    search: search ?? undefined,
    page: page ?? 1,
    limit: amount ?? 10,
    sort: sort?.sort ?? undefined,
    order: sort?.order ?? undefined,
    searchField: searchField ?? undefined,
    positionId: filter?.positionId !== undefined ? Number(filter.positionId) : undefined,
    userId: filter?.userId !== undefined ? Number(filter.userId) : undefined,
    departmentId: filter?.departmentId !== undefined ? Number(filter.departmentId) : undefined,
    functionalActivityId:
      filter?.functionalActivityId !== undefined ? Number(filter.functionalActivityId) : undefined,
    status:
      filter?.status === 'ACTIVE' || filter?.status === 'INACTIVE'
        ? filter.status
        : undefined,
    admissionDate: filter?.admissionDate as string | undefined,
    dismissalDate: filter?.dismissalDate as string | undefined,
  });

  return {
    data: result.data,
    metadata: {
      total: result.metadata.total,
      page: result.metadata.page,
      itemsPerPage: result.metadata.itemsPerPage,
      totalPages: result.metadata.totalPages,
      isNextPage: result.metadata.page < result.metadata.totalPages,
      isPreviousPage: result.metadata.page > 1,
    },
  };
}
